export default {
  // Sidebar
  'Nova OS Proativa': 'Nouvelle OS Proactive',
  'Interno': 'Interne',
  'Externo': 'Externe',
  'Preventiva': 'Préventive',
  'Preventiva Programada':  "Préventive programmée",
  "Preventiva Programada Armazém": "Préventive programmée Entrepôt",
  'Reaberta': 'Rouverte',
  'Execuções': 'Exécutions',
  'Armazém': 'Entrepôt',
  'Frota': 'Flotte',
  'Sair': 'Quitter',
  'Inventário': 'Inventaire',

  // Nova Os
  'Voltar': 'Retour',
  'Nova OS': 'Nouvelle OS',
  'Operação': 'Opération',
  'Placa': 'Immatriculation',
  'Segmento': 'Segment',
  'Problemas': 'Problèmes',
  'Descrição do Problema': 'Description du problème',
  'Gerar OS': 'Générer OS',
  'Cancelar': 'Annuler',

  // OS Interna
  "Nenhum resultado encontrado": 'Aucun résultat trouvé',
  "Exibindo resultado": 'Affichage du résultat',
  "de": 'de',
  "Aberta há": 'Ouverte depuis',
  "Concluída em": 'Terminée le',

  // Ordem Servico
  "Detalhes": 'Détails',
  "Mostrar": 'Afficher',
  "Esconder": 'Masquer',
  "Telefone": 'Téléphone',
  "Data": 'Date',
  "Início": 'Début',
  "Final": 'Fin',
  "Fornecedor": 'Fournisseur',
  "Tipo": 'Type',
  "Ciclo preventiva": 'Cycle préventif',
  "Criticidade": 'Criticité',
  "Previsão de Atendimento": 'Prévision d’intervention',
  "Atendimento do Item": 'Traitement de l’article',
  "Observações": 'Remarques',
  "Imagens": 'Images',
  "Salvar": 'Enregistrer',
  "Ordens de Serviço": 'Ordres de service',
    "GERADA_CHECKLIST": "GÉNÉRÉ À PARTIR DU CHECKLIST",
    "OBS_CHECKLIST": "OBSERVATIONS DU CHECKLIST :",
    "OS_INTERNA": "OS INTERNE :",

  // OS Item
  "Iniciar": 'Démarrer',
  "Ações": 'Actions',
  "Continuar": 'Continuer',
  "Pausar": 'Mettre en pause',
  "Registrar Peças": 'Enregistrer pièces',
  "Cancelar OS": 'Annuler l’OS',
  "OS Externa": 'OS Externe',
  "Insira um serviço. Tente novamente.": 'Saisissez un service. Réessayez.',
  "Falha ao carregar os dados da OS": "Échec du chargement des données de l’OS",
  "Falha ao carregar os itens da OS": "Échec du chargement des éléments de l’OS",

  // ModalItems
  "Serviços": 'Services',
  "SERVIÇOS": 'SERVICES',
  "Observação": 'Remarque',
  "Anexo de arquivos": 'Pièces jointes',
  "Informe o valor total dos serviços/peças": 'Indiquez la valeur totale des services/pièces',
  "Informe o motivo do socorro em rota": 'Indiquez le motif du dépannage sur la route',
  "Informe o pneu utilizado neste serviço": 'Indiquez le pneu utilisé pour ce service',
  "Foi trocado o pneu": 'Le pneu a été remplacé',
  "Finalizar OS": 'Clôturer l’OS',

  // Modal peças
  "Foi utilizado Peças?": 'Des pièces ont été utilisées ?',
  "Se foi utilizado peças neste atendimento, pressione 'Sim' na opção abaixo!":
    "Si des pièces ont été utilisées, appuyez sur 'Oui' ci-dessous !",
  "Não": 'Non',
  "Sim": 'Oui',

  // Modal Itens Fim
  "Informe os itens utilizados neste serviço": 'Indiquez les articles utilisés pour ce service',
  "Fechar": 'Fermer',
  "Peças": 'Pièces',
  "Peça": 'Pièce',
  "Quantidade": 'Quantité',
  "Preço": 'Prix',
  "Informe o pneu novo": 'Indiquez le pneu neuf',

  // Modal Pause
  "Informe a Justificativa": 'Indiquez la justification',
  "Confirmar Pausa": 'Confirmer la pause',
  "Justificativa": 'Justification',
  "Ir ao banheiro": 'Aller aux toilettes',
  "Fim de expediente": 'Fin de journée',
  "Atendimento": 'Intervention',
  "Refeição": 'Repas',
  "Aguardando Peças": 'En attente de pièces',
  "Auxílio externo": 'Aide externe',
  'Selecione qual peça está aguardando': 'Sélectionnez la pièce en attente',

  // Confirmar OS Externa
  "Confirmar OS Externa": 'Confirmer OS Externe',
  "Deseja realmente enviar OS": 'Voulez-vous vraiment envoyer l’OS',
  "Confirmar": 'Confirmer',

  // Lista de Execucao
  "Lista de execução": 'Liste d’exécution',
  "Nenhuma execução ativa": 'Aucune exécution active',
  "Início Atendimento": 'Début de l’intervention',
  "Encerrar OS": 'Fermer l’OS',
  "Acessar OS": 'Accéder à l’OS',
  "Colaborador": 'Collaborateur',
  "Execuções em Pause": 'Exécutions en pause',
  "Nenhuma execução em pause": 'Aucune exécution en pause',

  // Login
  "Torne sua rotina mais dinâmica": 'Rendez votre routine plus dynamique',
  "ACESSO AO SISTEMA": 'ACCÈS AU SYSTÈME',
  "Terminal Oficina": 'Terminal Atelier',
  "Realize o login e tenha acesso ao controle": 'Connectez-vous pour accéder au contrôle',
  "e gestão de suas Ordens de Serviço": 'et à la gestion de vos ordres de service',
  "Mecânico Externo": 'Mécanicien Externe',
  "Acessar": 'Accéder',
  "Falha ao fazer login": 'Échec de connexion',

  // Filtro Internas
  "Ordenar": 'Trier',
  "Antigas Primeiro": 'Plus anciennes d’abord',
  "Recentes Primeiro": 'Plus récentes d’abord',
  "Maior": 'Plus grand',
  "Menor": 'Plus petit',
  "Segmentos": 'Segments',
  "Período": 'Période',
  "Execução": 'Exécution',
  "Todos": 'Tous',
  "Pendentes": 'En attente',
  "Finalizadas": 'Finalisées',
  "Aplicar filtro": 'Appliquer le filtre',
  "Limpar filtros": 'Effacer filtres',
  "Esconder filtros": 'Masquer filtres',
  "Criado por": 'Créée par',
  "Usuário": 'Utilisateur',
  "Ação": "Action",

  // Os Preventivas
  "Filtre as OS Preventivas": 'Filtrer les OS préventives',
  "Preventivas Vencidas": 'Préventives expirées',
  "Preventivas à Vencer": 'Préventives à expirer',
  "Carrocerias Vencidas": 'Carrosseries expirées',
  "Carrocerias à Vencer": "Carrosseries de voitures à gagner",
  "Atualizar": 'Actualiser',

  // Modais Preventivas
  "ACAO": 'ACTION',
  "PLACA": 'IMMAT',
  "PROXIMO_CICLO": 'PROCHAIN CYCLE',
  "VENCIMENTO": 'ÉCHÉANCE',
  "PROXIMO_KM": 'PROCHAIN KM',
  "KM_ATUAL": 'KM ACTUEL',
  "Vincular Fornecedor": 'Lier un fournisseur',

  // Inventário
  'Iniciar novo inventário': 'Démarrer un nouvel inventaire',
  'Dt Inicial': 'Date de début',
  'Dt Final': 'Date de fin',
  "Não contados": 'Non comptés',
  "Contados": 'Comptés',
  "Ordenação": 'Tri',
  "Total Itens": 'Total articles',
  "Status": "Statut",
  "Inventário criado com sucesso!": "Inventaire créé avec succès!",
  "Já existe um inventário em execução": "Il existe déjà un inventaire en cours",
  "Deseja iniciar um novo inventário?": "Souhaitez-vous démarrer un nouvel inventaire ?",
  "Inventário de Estoque": "Inventaire de Stock",

  // Modal Mecanico
  "Informe os três primeiros dígitos do seu CPF para confirmar sua identidade":
    'Saisissez les trois premiers chiffres de votre CPF pour confirmer votre identité',
  'Confirmar identidade': 'Confirmer l’identité',

  "Erro do Motorista": 'Erreur du conducteur',
  "Defeito não Encontrado": 'Défaut non trouvé',

  "Informe o serviço": 'Indiquez le service',
  "Insira os Itens": 'Saisir les articles',

  "Alterar Fornecedor": 'Changer le fournisseur',
  "Preventivas Armazém": 'Préventives Entrepôt',
  "Outros": 'Autres',
  "Ver Encerradas": 'Voir clôturées',
  "Tem dúvida?": 'Vous avez une question ?',
  "Aguardando Aprovação": 'En attente d’approbation',

  // Complementos Borracharia
  'Bem vindo(a) ao Terminal da Borracharia!': 'Bienvenue au terminal de la pneumatique !',
  'Realize a gestão de pneus pelo novo terminal da borracharia!':
    'Gérez les pneus via le nouveau terminal de la pneumatique !',
  'Aferição': 'Contrôle',
  'Movimentação/Troca': 'Mouvement/Remplacement',
  'Descarte': 'Mise au rebut',
  'Borracharia': 'Pneumatique',
  'Placas': 'Immatriculations',

  // Gerais
  "Portugues": 'Português',
  "Nunca feito": 'Jamais effectué',
  "Ingles": 'Anglais',
  'Frances': "Français",
  'Alemao': 'Allemand',
  'Holandes': 'Néerlandais',
  'Espanhol': 'Espagnol',

    
  "O ESFORÇO DE HOJE É O SUCESSO DE AMANHA": "L'EFFORT D'AUJOURD'HUI EST LE SUCCÈS DE DEMAIN",

  "CODIGO OS": "CODE OT",
  "TODOS": "TOUS",
  "Socorro em Rota pendente de atendimento": "Assistance routière en attente de prise en charge",
  "FILTROS": "FILTRES",
  "Salvar Filtro": "Enregistrer le filtre",
  "Motorista": "Conducteur",
  "Orçamento": "Budget",
  "Confirmar Orçamento": "Confirmer le budget",
  "Deseja pausar esta OS para aguardar o orçamento?": "Souhaitez-vous mettre cet ordre de travail en pause pour attendre le budget ?",
  "Valor": "Valeur",
  "Pausar OS": "Mettre l’OT en pause",
  "Comentarios": "Commentaires",
  "Insira um comentário": "Saisissez un commentaire",
  "Enviar OS": "Envoyer l’OT",
  "Selecione uma justificativa": "Sélectionnez une justification",
  "Anexos": "Pièces jointes",
  "OS Socorro em Rotas": "OT Assistance routière",
  "Confirmar Cancelamento": "Confirmer l’annulation",
  "Buscar Placa": "Rechercher la plaque",
  "Pesquisa de OS por placa": "Recherche d’OT par plaque",
  "CONTRATO_CONCESSIONARIA": "CONTRAT DE CONCESSIONNAIRE",

  "Ordem gerada com sucesso": "Ordre généré avec succès",
  "Sucesso": "Succès",
  "Selecionar Todos": "Tout sélectionner",
  "Descrição": "Description",
  "Registrar Serviços": "Enregistrer les services",
  "Visualizar Itens": "Afficher les éléments",
  "Clique no botão a direita para registrar as peças": "Cliquez sur le bouton à droite pour enregistrer les pièces",

  "Selecionar técnico": "Sélectionner le technicien",
  "KM atual/Horimetro": "Kilométrage actuel / Horomètre",
  "Deseja inserir alguma imagem no atendimento": "Souhaitez-vous ajouter une image à l’intervention ?",
  "Para concluir a ação, selecione abaixo o técnico responsável": "Pour finaliser l’action, sélectionnez ci-dessous le technicien responsable",
  "Trabalhando": "En cours de travail",
  "Matricula": "Matricule",
  "Serviços registrado com sucesso": "Services enregistrés avec succès",
  "Função": "Fonction",
  "Enviar Anexos": "Envoyer les pièces jointes",
  "Gerar Preventiva Programada": "Générer une maintenance préventive planifiée",
  "OS Preventiva Programada": "OT préventive planifiée",
  "Finalize todas as peças e serviços para encerrar o atendimento": "Finalisez toutes les pièces et services pour clôturer l'intervention",
  "Insira um KM maior que o anterior": "Saisissez un kilométrage supérieur au précédent",
  "Insira um KM maior que o atual": "Saisissez un kilométrage supérieur à l’actuel",
  "Inserir anexos": "Ajouter des pièces jointes",
  "Planos Preventivos": "Plans préventifs",
  "Filtro": "Filtre",
  "ULTIMA": "DERNIÈRE",
  "Gerar Preditiva": "Générer une maintenance prédictive",
  "Carregando": "Chargement",
  "OS Preventiva Programada Armazém": "OT préventive planifiée – Entrepôt",
  "Gerar OS Preventiva Programada": "Générer une OT préventive planifiée",
  "OS Preventivas à Vencer": "OT préventives arrivant à échéance",
  "OS de Transição": "Transition du système d'exploitation",

  "IMEDIATA": "IMMÉDIATE",
  "EMERGENCIAL": "URGENCE",
  "ALTA": "ÉLEVÉE",
  "MÉDIA": "MOYENNE",
  "LEVE": "FAIBLE",

  "Registrar Tarefas": "Enregistrer les Tâches",
  "Desbloqueia Empilhadeira": "Débloquer le Chariot Élévateur",
  "OS Ag. Aprovação": "OT en Attente d'Approbation",
  "OS Internas Veículos": "OT Internes – Véhicules",
  "OS Internas Armazém": "OT Internes – Entrepôt",
  "OS Reabertas": "OT Réouvertes",
  "Criticidade de OS Abertas": "Criticité des OT Ouvertes",
  "Top 20 Placas com mais OS": "Top 20 Plaques avec le plus d'OT",
  "Qtd OS": "Quantité d'OT",

  // Dashboard
  "Criticidade de OS abertas": "Criticité des OT ouvertes",
  "URGENTE": "URGENT",
  "PREVENTIVA": "PRÉVENTIVE",
  "CRITICIDADES": "CRITICITÉS",
  "Bem Vindo(a)": "Bienvenue",
  "Tenha acesso as principais": "Accédez aux principales",
  "informações da sua mecânica!": "informations de votre atelier!",
  "Ver OS internas": "Voir les OT internes",
  "OS TicketLog": "OT TicketLog",
  "OS Externas": "OT Externes",
  "OS Interna Veículos": "OT Interne Véhicules",
  "OS Interna Armazém": "OT Interne Entrepôt",
  "Ranking dos Mecânicos": "Classement des Mécaniciens",
  "Tipo de OS": "Type d'OT",
  "Atendidas nos últimos 30 dias": "Traitées au cours des 30 derniers jours",
  "TOP 20 Placas com mais OS": "TOP 20 Plaques avec le plus d'OT",
  "Últimos 30 dias": "30 derniers jours",
  "Placas com OS Externas": "Plaques avec OT Externes",
  "TOP 10 Problemas mais atendidos": "TOP 10 Problèmes les plus traités",
  "Nos últimos 30 dias": "Au cours des 30 derniers jours",
  "Status por Mecânico": "Statut par Mécanicien",
  "Produtividade": "Productivité",

  // ModalEncerradas
  "Filtros": "Filtres",
  "NÚMERO": "NUMÉRO",
  "INÍCIO": "DÉBUT",
  "FINAL": "FIN",
  "SEGMENTO": "SEGMENT",
  "PROBLEMA": "PROBLÈME",

  // Login
  "Acesso Rápido": "Accès rapide",
  "ID": "ID",
  "CNPJ": "ID",
  "codigo_fornec": "code",
  "Para qual fornecedor você deseja enviar esta OS": "À quel fournisseur souhaitez-vous envoyer cette commande",
  'Se foi utilizado peças neste atendimento, pressione "Sim" na opção abaixo!': "Si des pièces ont été utilisées lors de cette intervention, appuyez sur « Oui » dans l'option ci-dessous",
  "FILTRO EMPRESA": "FILTRE D'ENTREPRISE",
  "Upload Arquivos": "Télécharger des fichiers",
  "Cards": "Cartes",
  "Colunas": "Colonnes",
  "ULTIMA MM": "DERNIÈRE MM",
  "PRÓXIMA MM": "PROCHAINE MM",
  "ULTIMA CAL": "DERNIÈRE CAL",
  "PRÓXIMA CAL": "PROCHAINE CAL",

  "ULTIMA MOVIMENTACAO": "DERNIÈRE MOVIMENTATION",
  "PRÓXIMA MOVIMENTACAO": "PROCHAINE MOVIMENTATION",
  "Descartes": "Mises au rebut",  
  "N° FOGO": "N° FOGO",
  "FILIAL": "BIFURQUER",
  "MARCA": "MARQUE",
  "MODELO": "MODÈLE",
  "MEDIDA": "MESURE",
  "POSIÇÃO": "POSITION",
  "Aguardando Aprovação de Sinistro": "En attente d'approbation du sinistre",
  "Aguardando Liberacao": "En attente de libération",
  "Nenhuma OS aguardando liberacao": "Aucun ordre de service en attente de libération",
  
  "O tempo total é inferior a 5 minutos. Isso poderá impactar negativamente no controle de gestão": 
  "Le temps total est inférieur à 5 minutes. Cela pourrait avoir un impact négatif sur le contrôle de gestion",
  "Aguardar Liberação": "En attente de libération",

  "CONTRATO CONCESSIONARIA": "CONTRAT DE CONCESSION",
  "Nenhuma OS aguardando aprovação": "Aucune demande de service en attente d'approbation",

    // Chaves adicionadas para i18n completo
    "Adicionar Serviços": "Ajouter des services",
    "Aferindo NR Fogo": "Mesure du n° feu",
    "AFERIÇÃO": "MESURE",
    "Aderência Aferição 01": "Adhérence mesure",
    "Aderência Aferição 02": "Adhérence mesure",
    "AÇÃO": "ACTION",
    "CALIBRAGEM": "GONFLAGE",
    "CD_PNEU": "CODE_PNEU",
    "CONJUNTO": "ENSEMBLE",
    "CPF (3 primeiros digitos)": "CPF (3 premiers chiffres)",
    "Cadastro": "Enregistrement",
    "Calibragem NR Fogo": "Gonflage n° feu",
    "Comece a digitar o nome do fornecedor para exibir na lista abaixo": "Commencez à saisir le nom du fournisseur pour l’afficher dans la liste ci-dessous",
    "Confirmar envio Ticket": "Confirmer l’envoi du ticket",
    "Conserto de Pneus": "Réparation de pneus",
    "DATA": "DATE",
    "DS_PREDITIVO": "DESCRIPTION PRÉDICTIVE",
    "DashBoard": "Tableau de bord",
    "Dashboard": "Tableau de bord",
    "Data Final": "Date de fin",
    "Data Inicial": "Date de début",
    "Data OS": "Date OS",
    "Dentro do Prazo": "Dans les délais",
    "Descartar": "Écarter",
    "Descarte Pneus": "Mise au rebut des pneus",
    "Deseja enviar para TicketLog a OS": "Voulez-vous envoyer l’OS à TicketLog",
    "Digite para pesquisar": "Tapez pour rechercher",
    "Enviar": "Envoyer",
    "Equipamento Liberado": "Équipement libéré",
    "Escreva seu script aqui": "Écrivez votre script ici",
    "Externas Armazém": "Externes entrepôt",
    "FOGO": "FEU",
    "Fora do Prazo": "Hors délai",
    "Informar Aferição": "Saisir la mesure",
    "Informar Calibragem": "Saisir le gonflage",
    "Informar KM": "Saisir KM",
    "Informar Sinistro": "Signaler un sinistre",
    "Informe o KM do Pneu": "Indiquez le KM du pneu",
    "Informe o serviço feito!": "Indiquez le service effectué !",
    "Insira o KM do veículo:": "Saisissez le KM du véhicule :",
    "Insira os Serviços": "Insérez les services",
    "Inventário de estoque": "Inventaire de stock",
    "Inverter pneus": "Inverser les pneus",
    "Início Atendimento OS": "Début intervention OS",
    "Item": "Article",
    "Itens:": "Articles :",
    "KM": "KM",
    "KM PROX.": "KM SUIV.",
    "Lançamento de item": "Saisie d’article",
    "Lista": "Liste",
    "Matrícula": "Matricule",
    "Motivo": "Motif",
    "NR Fogo": "N° feu",
    "Novas Aferições": "Nouvelles mesures",
    "OS Encerradas - Últimas 15 OS": "OS clôturées - 15 dernières OS",
    "OS Preventiva Vencida": "OS préventive en retard",
    "OS Preventivas Vencidas": "OS préventives en retard",
    "Observacao": "Remarque",
    "PROX. CICLO": "CYCLE SUIV.",
    "Para qual fornecedor você deseja enviar esta OS?": "À quel fournisseur voulez-vous envoyer cette OS ?",
    "Pendente": "En attente",
    "Pesquisa global": "Recherche globale",
    "Pesquisar": "Rechercher",
    "Pesquisar Item": "Rechercher un article",
    "Pesquisar peça": "Rechercher une pièce",
    "Pesquisar serviço": "Rechercher un service",
    "Planos": "Plans",
    "Pneus a Placa:": "Pneus de la plaque :",
    "Problema": "Problème",
    "Próximo Ciclo": "Cycle suivant",
    "Pular": "Ignorer",
    "Realizar avaliação": "Réaliser l’évaluation",
    "Registrar Aferições": "Enregistrer les mesures",
    "Selecione a empresa": "Sélectionnez l’entreprise",
    "Selecione um Pneu": "Sélectionnez un pneu",
    "Selecione um fornecedor": "Sélectionnez un fournisseur",
    "Selecione um motivo": "Sélectionnez un motif",
    "Servicos": "Services",
    "Serviço": "Service",
    "Sinalizar Sinistro": "Signaler un sinistre",
    "Sucesso!": "Succès !",
    "TIPO": "TYPE",
    "Vencimento": "Échéance",
    "de Calibragem": "de gonflage",
    "Última Aferição": "Dernière mesure",
    "Última aferição NR fogo": "Dernière mesure n° feu",

    // Chaves complementares
    "Precisa de Ajuda?": "Besoin d’aide ?",

    // Mensagens de validação
    "Preenchimento obrigatório": "Champ obligatoire",
    "Disponível": "Disponible",
    "Deve ser maior que 0": "Doit être supérieur à 0",
    "Não pode ser negativo": "Ne peut pas être négatif",
    "Valor Unitário": "Valeur unitaire",
    "Existem filtros salvos e aplicados": "Des filtres sont enregistrés et appliqués",
    "Adicionar Arquivos": "Ajouter des fichiers",
    "Ordem de Serviço criada com Sucesso": "Ordre de travail créé avec succès",
"Falha ao parar execução. Tente novamente": "Échec de l'arrêt de l'exécution. Veuillez réessayer.",
"Selecionar": "Sélectionner",
"Insira todas as informações": "Saisissez toutes les informations",
"Item registrado com sucesso": "Élément enregistré avec succès",
"Insira um preço": "Saisissez un prix",
"OS Preventiva A Vencer": "Ordres de travail préventifs arrivant à échéance",
"OS já está aberta": "L'ordre de travail est déjà ouvert",
"Não trabalhando": "Ne travaille pas",

"ABASTECIMENTO": "RAVITAILLEMENT",
"CHECKLIST": "LISTE DE CONTRÔLE",
"CHECKLIST CONFORMIDADE": "LISTE DE CONTRÔLE DE CONFORMITÉ",
"PREVENTIVA CARROCERIA": "MAINTENANCE PRÉVENTIVE DE LA CARROSSERIE",
"SOCORRO EM ROTA": "ASSISTANCE ROUTIÈRE",
}
